import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import vuePagination from 'vue-pagination-y'//分页
import 'animate.css'

Vue.use(vuePagination)
Vue.config.productionTip = false

new Vue({
	el:'#app',
  router,
  store,
  render: h => h(App),
	mounted() {
		// You'll need this for renderAfterDocumentEvent.
		document.dispatchEvent(new Event('render-event'))
	}
})
